export const searchUser = () => {
  // 検索ボタン
  const searchButton = document.getElementById( 'js-search-button' );

  // テーブル
  // const searchHide   = document.getElementById( 'js-hide' );
  // searchHide.style.display = 'none';

  // 登録ボタン
  const registButton  = document.querySelector( '.p-search-header__button .c-button-register' );

  // 編集ボタン
  const editButtons  = document.querySelectorAll( '.p-search-table__controller-item .edit' );

  // 削除ボタン
  const deleteButtons  = document.querySelectorAll( '.p-search-table__controller-item .delete' );

  // 担当ユーザーID
  const userButtons  = document.querySelectorAll( '.p-search-table__item .user' );

  // モーダルウィンドウ
  const modalRegist      = document.querySelector( '.js-modal-regist' );
  const modalRegistNext  = document.querySelector( '.js-modal-regist-next' );
  const modalEdit        = document.querySelector( '.js-modal-edit' );
  const modalEditNext    = document.querySelector( '.js-modal-edit-next' );
  const modalDelete      = document.querySelector( '.js-modal-delete' );
  const modalUser        = document.querySelector( '.js-modal-user' );

  searchButton.addEventListener( 'click', () => {
    // searchHide.style.display = 'block';
  } );

  registButton.addEventListener( 'click', () => {
    modalRegist.classList.add( 'is--show' );
  } );

  editButtons.forEach( item => {
    item.addEventListener( 'click', () => {
      modalEdit.classList.add( 'is--show' );
    } );
  } );

  deleteButtons.forEach( item => {
    item.addEventListener( 'click', () => {
      modalDelete.classList.add( 'is--show' );
    } );
  } );

  userButtons.forEach( item => {
    item.addEventListener( 'click', () => {
      modalUser.classList.add( 'is--show' );
    } );
  } );

  modalRegist.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
    modalRegist.classList.remove( 'is--show' );
  } );
  modalRegistNext.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
    modalRegistNext.classList.remove( 'is--show' );
  } );
  modalEdit.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
    modalEdit.classList.remove( 'is--show' );
  } );
  modalEditNext.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
    modalEditNext.classList.remove( 'is--show' );
  } );
  modalDelete.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
    modalDelete.classList.remove( 'is--show' );
  } );
  modalUser.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
    modalUser.classList.remove( 'is--show' );
  } );

  document.querySelector( '.js-regust-next' ).addEventListener( 'click', ( e ) => {
    modalRegist.classList.remove( 'is--show' );
    modalRegistNext.classList.add( 'is--show' );
    e.preventDefault();
  } );

  document.querySelector( '.js-edit-next' ).addEventListener( 'click', ( e ) => {
    modalEdit.classList.remove( 'is--show' );
    modalEditNext.classList.add( 'is--show' );
    e.preventDefault();
  } );

  /**
   * 戻るボタン
   */
  const buttonPrevRegistInput = document.getElementById( 'js-modal-regist-input-prev' );
  buttonPrevRegistInput.addEventListener( 'click', () => {
    modalRegist.classList.remove( 'is--show' );
  } );

  const buttonPrevRegistInputNext = document.getElementById( 'js-modal-regist-input-next-prev' );
  buttonPrevRegistInputNext.addEventListener( 'click', () => {
    modalRegistNext.classList.remove( 'is--show' );
    modalRegist.classList.add( 'is--show' );
  } );

  const buttonPrevEditInput = document.getElementById( 'js-modal-edit-input-prev' );
  buttonPrevEditInput.addEventListener( 'click', () => {
    modalEdit.classList.remove( 'is--show' );
  } );

  const buttonPrevEditNextInput = document.getElementById( 'js-modal-edit-input-next-prev' );
  buttonPrevEditNextInput.addEventListener( 'click', () => {
    modalEditNext.classList.remove( 'is--show' );
    modalEdit.classList.add( 'is--show' );
  } );

  const buttonPrevDelete = document.getElementById( 'js-modal-delete-prev' );
  buttonPrevDelete.addEventListener( 'click', () => {
    modalDelete.classList.remove( 'is--show' );
  } );


  /**
   * 個別設定
   */
  // ページ読み込み時
  $( 'input[data-switch-kobetsu]:checked' ).each( function () {
    const data = $( this ).attr( 'data-switch-kobetsu' );
    if ( data == 'On' ) {
      $( this ).parent().parent().next( '.p-special-select').removeClass( 'is--disabled' );
      $( this ).parent().parent().next( '.p-special-select').find( '.c-checkbox' ).removeAttr('checked').prop("checked", false).change();
    } else {
      $( this ).parent().parent().next( '.p-special-select').addClass( 'is--disabled' );
      $( this ).parent().parent().next( '.p-special-select').find( '.c-checkbox' ).attr('checked', true).prop('checked', true).change();
    }
  } );

  // イベント時
  $( 'input[data-switch-kobetsu]' ).on( 'change', function () {
    const data = $( this ).attr( 'data-switch-kobetsu' );
    if ( data == 'On' ) {
      $( this ).parent().parent().next( '.p-special-select').removeClass( 'is--disabled' );
      $( this ).parent().parent().next( '.p-special-select').find( '.c-checkbox' ).removeAttr('checked').prop("checked", false).change();
    } else {
      $( this ).parent().parent().next( '.p-special-select').addClass( 'is--disabled' );
      $( this ).parent().parent().next( '.p-special-select').find( '.c-checkbox' ).attr('checked', true).prop('checked', true).change();
    }
  } );


  /**
   * 照会
   */
  $( 'input[data-switch-shokai]' ).parent().parent().next().css( 'display', 'none' );

  // ページ読み込み時
  $( 'input[data-switch-shokai]' ).each( function () {
    if ( $(this).prop('checked') == true ) {
      $( this ).addClass( 'is-on' );
      $( this ).parent().parent().next().css( 'display', 'block' );
    }
  } );

  // イベント時
  $( 'input[data-switch-shokai]' ).on( 'change', function () {
    if ( $(this).prop('checked') == true ) {
      $( this ).addClass( 'is-on' );
    } else {
      $( this ).removeClass( 'is-on' );
    }
    if ( $( this ).hasClass( 'is-on' ) ) {
      $( this ).parent().parent().next().css( 'display', 'block' );
    } else {
      $( this ).parent().parent().next().css( 'display', 'none' );
    }
  } );
}
